export * from './IconLaptopStroked';
